import React from 'react';
import { Stack } from '@mui/material';
import Documents from './Documents';
import Notifications from './Notifications';

const DocumentsAndNotifications = ({ updateOrders, formik }) => (
  <Stack m={2} spacing={2}>
    <Documents updateOrders={updateOrders} formik={formik} />
    <Notifications formik={formik} />
  </Stack>
);


export default DocumentsAndNotifications;
